import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  UserIcon,
  DocumentTextIcon,
  PhotoIcon,
  HeartIcon,
  Squares2X2Icon,
  BookmarkIcon,
  CurrencyDollarIcon,
  GiftIcon
} from '@heroicons/react/24/outline';
import { getCurrentUser } from '../data/mockData';

interface AccountSidebarProps {
  currentPage: string;
}

const AccountSidebar: React.FC<AccountSidebarProps> = ({ currentPage }) => {
  const user = getCurrentUser();
  const location = useLocation();

  if (!user) {
    return null;
  }

  const menuItems = [
    { 
      name: 'Account Overview', 
      icon: UserIcon, 
      href: '/account',
      page: 'account'
    },
    { 
      name: 'My Orders', 
      icon: DocumentTextIcon, 
      href: '/orders',
      page: 'orders'
    },
    { 
      name: 'Saved Designs', 
      icon: BookmarkIcon, 
      href: '/saved-designs',
      page: 'saved-designs'
    },
    { 
      name: 'My Images', 
      icon: PhotoIcon, 
      href: '/my-images',
      page: 'my-images'
    },
    { 
      name: 'Likes', 
      icon: HeartIcon, 
      href: '/likes',
      page: 'likes'
    },
    // { 
    //   name: 'Collections', 
    //   icon: Squares2X2Icon, 
    //   href: '/collections',
    //   page: 'collections'
    // },
    { 
      name: 'Income & Earnings', 
      icon: CurrencyDollarIcon, 
      href: '/income',
      page: 'income'
    },
    { 
      name: 'Referral Coupons', 
      icon: GiftIcon, 
      href: '/referrals',
      page: 'referrals'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-12 h-12 rounded-full flex items-center justify-center overflow-hidden" style={{ backgroundColor: '#f0f2f5' }}>
          <UserIcon className="w-6 h-6" style={{ color: '#2e3a47' }} />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900">{user.firstName} {user.lastName}</h3>
          <p className="text-sm text-gray-500">{user.email}</p>
        </div>
      </div>

      <nav className="space-y-2">
        {menuItems.map((item) => {
          const isActive = currentPage === item.page;
          const IconComponent = item.icon;
          
          return (
            <Link 
              key={item.name}
              to={item.href}
              className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                isActive 
                  ? 'font-medium' 
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
              style={isActive ? { backgroundColor: '#f0f2f5', color: '#2e3a47' } : {}}
            >
              <IconComponent className="w-5 h-5" />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default AccountSidebar; 